<template>
    <svg viewBox="0 0 22 62" class="boat-svg">

        <path
            d="M15.46,45.26c0-23.93-3-38.2-5.86-42.78C8.31.39,8.19.6,6.9,2.55,4,6.88,1,20.91,1,45.26,1.21,57.39,15.46,57.9,15.46,45.26Z"
            :fill="color" stroke="#1d1d1b" />


        <rect x="-8" y="31" width="5" height="14" :fill="color" />
        <rect x="19.5" y="31" width="5" height="14" :fill="color" />
    </svg>
</template>

<script>
export default {
    props: ['color']
}
</script>